import { Turbo } from "@hotwired/turbo-rails"
import { Controller } from "@hotwired/stimulus"

/*
 * Puts the Amazon Key terms in front of a property manager the moment they
 * switch the integration on, and again whenever legal publish a new version.
 *
 * Accepting is a precondition of ticking the box, not of saving the page, so
 * the prompt fires on the checkbox: declining simply unticks it and leaves the
 * rest of the settings alone rather than interrupting a save the manager has
 * already committed to. A manager who never touches Amazon Key is never asked
 * to agree to anything.
 *
 * Consent is recorded in a hidden field, and the server validates it too, so
 * getting past this prompt still cannot activate the integration on its own.
 */
export default class extends Controller {
  static targets = ["accepted"]
  static values = {
    title: String,
    bodyHtml: String,
    accept: String
  }

  async confirmTerms(event) {
    const checkbox = event.target

    // Unticking needs no agreement, and neither does an already accepted version.
    if (!checkbox.checked) return
    if (!this.hasAcceptedTarget || this.acceptedTarget.value === "1") return

    const confirmed = await Turbo.config.forms.confirm("", this.element, this.confirmationSubmitter())

    if (confirmed) {
      this.acceptedTarget.value = "1"
      return
    }

    checkbox.checked = false
    // Let the other controllers watching this box collapse the section again.
    checkbox.dispatchEvent(new Event("change", { bubbles: true }))
  }

  // Turbo reads the modal's wording off the submitter, so stand one in — there
  // is no real submitter when the prompt comes from a checkbox.
  confirmationSubmitter() {
    const stub = document.createElement("button")

    stub.dataset.confirmTitle = this.titleValue
    stub.dataset.confirmAccept = this.acceptValue
    stub.dataset.confirmBodyHtml = this.bodyHtmlValue

    return stub
  }
}
